import { Controparte } from '../../../models/controparte';
import { Parte } from '../../../models/parte';

export class ControparteAssociativaAdapter {

  controparte: Controparte = new Controparte();

  constructor(controparte: Controparte) {
    this.controparte.id = controparte.id;
    this.controparte.parte = controparte.parte ? JSON.parse(JSON.stringify(controparte.parte)) : new Parte();
    this.controparte.parte.id = controparte.parte.id;
    this.controparte.parte.nome = controparte.parte.nome;
    this.controparte.parte.cognome = controparte.parte.cognome;
    this.controparte.parte.codiceFiscale = controparte.parte.codiceFiscale;
    this.controparte.parte.dipendente = controparte.parte.dipendente ? controparte.parte.dipendente : false;
    this.controparte.parte.vivente = controparte.parte.vivente ? controparte.parte.vivente : false;
    this.controparte.parte.matricola = controparte.parte.matricola;
    this.controparte.parte.ragioneSociale = controparte.parte.ragioneSociale;
    this.controparte.parte.partitaIva = controparte.parte.partitaIva;
    this.controparte.parte.dataNascita = controparte.parte.dataNascita;
    this.controparte.parte.indirizzo = controparte.parte.indirizzo;
    this.controparte.parte.cap = controparte.parte.cap;
    this.controparte.parte.telefono = controparte.parte.telefono;
    this.controparte.parte.cellulare = controparte.parte.cellulare;
    this.controparte.parte.email = controparte.parte.email;
    this.controparte.parte.pec = controparte.parte.pec;
    this.controparte.parte.note = controparte.parte.note;
    this.controparte.parte.tipoPersona = controparte.parte.tipoPersona ?  JSON.parse(JSON.stringify(controparte.parte.tipoPersona)) : null;
    this.controparte.parte.tipoSocieta = controparte.parte.tipoSocieta ?  JSON.parse(JSON.stringify(controparte.parte.tipoSocieta)) : null;
    this.controparte.parte.comuneNascita = controparte.parte.comuneNascita ?  JSON.parse(JSON.stringify(controparte.parte.comuneNascita)) : null;
    this.controparte.parte.provinciaNascita = controparte.parte.provinciaNascita ?  JSON.parse(JSON.stringify(controparte.parte.provinciaNascita)) : null;
    this.controparte.parte.comuneResidenza = controparte.parte.comuneResidenza ?  JSON.parse(JSON.stringify(controparte.parte.comuneResidenza)) : null;
    this.controparte.parte.provinciaResidenza = controparte.parte.provinciaResidenza ?  JSON.parse(JSON.stringify(controparte.parte.provinciaResidenza)) : null;
    this.controparte.primario = controparte.primario ? controparte.primario : false;
    this.controparte.ritirato = controparte.ritirato ? controparte.ritirato : false;
    this.controparte.cliente = controparte.cliente ? controparte.cliente : false;
    this.controparte.note = controparte.note;
    this.controparte.legaleControparte = controparte.legaleControparte ?  JSON.parse(JSON.stringify(controparte.legaleControparte)) : null;
    this.controparte.dataAssociazione = controparte.dataAssociazione;
    this.controparte.dataTermine = controparte.dataTermine;
    this.controparte.documenti = controparte.documenti;
    this.controparte.categoria = controparte.categoria;
    this.controparte.flagAttore = controparte.flagAttore ? controparte.flagAttore : false;
  }
}
